import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BusinessDashboardNav from '../../components/ui/BusinessDashboardNav';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const EventsPage = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const navigate = useNavigate();

  const user = {
    name: "Event Manager",
    role: "Event Manager"
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-background">
      <BusinessDashboardNav
        userRole="event-manager"
        isCollapsed={isNavCollapsed}
        onToggleCollapse={() => setIsNavCollapsed(!isNavCollapsed)}
        user={user}
      />
      
      <div className={`transition-all duration-300 ${isNavCollapsed ? 'lg:ml-16' : 'lg:ml-64'}`}>
        <header className="bg-card border-b border-border shadow-sm px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-foreground">Manage Events</h1>
              <p className="text-sm text-muted-foreground">
                Create, edit, and manage your events
              </p>
            </div>
            <Button
              variant="outline"
              size="sm"
              iconName="LogOut"
              onClick={handleLogout}
            >
              Sign Out
            </Button>
          </div>
        </header>

        <main className="p-6 pb-20 lg:pb-6">
          <div className="max-w-7xl mx-auto">
            <div className="bg-card rounded-lg border border-border p-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-primary rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Icon name="Calendar" size={32} color="white" />
                </div>
                <h2 className="text-xl font-semibold text-foreground mb-2">Event Management</h2>
                <p className="text-muted-foreground mb-6">
                  This page is under development. Event management functionality will be available soon.
                </p>
                <Button
                  onClick={() => navigate('/event-manager-dashboard')}
                  iconName="ArrowLeft"
                >
                  Back to Dashboard
                </Button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default EventsPage;